if not App.angularApp?
    return

# Alternative to the `ui-select-no-choice` directive, which inexplicably fails
# https://github.com/angular-ui/ui-select/wiki/ui-select-no-choice
# It fails because "This directive work only with bootstrap theme." -AK
# NOTE: this does not disable the ui-select, so be sure to add the appropriate
# conditions to the ng-disabled directive.
App.angularApp.directive 'mfNoOptions', () ->
    return {
        restrict: 'A'
        require: 'uiSelect'
        link: (scope, element, attrs, uiSelect) =>
            no_options = attrs.mfNoOptions or 'No options'
            unwatch = scope.$watch '$select.placeholder', (placeholder) ->
                if placeholder
                    unwatch()
                    original_placeholder = placeholder

                    # we can't just watch $select.items because that reflects filtering
                    repeat_attr = $(element.find('.ui-select-choices')[0]).attr('repeat')
                    [junk, array_name] = repeat_attr.match(/\s+in\s+(\S+)/)
                    scope.$parent.$watchCollection array_name, (items) ->
                        if (items? and not items.length) or not items?
                            scope.$select.placeholder = no_options
                        else
                            scope.$select.placeholder = original_placeholder
    }
